import { Component } from '@angular/core';

@Component({
  selector: 'app-sport-events',
  templateUrl: './sport-events.component.html',
  styleUrls: ['./sport-events.component.scss']
})
export class SportEventsComponent {

  constructor() {}

  filterInnerTabs(year: string, event: Event, containerId: string) {

    // IMPORTANT FIX
    const target = event.currentTarget as HTMLElement;

    // Nav container
    const parentNav = target.closest('.nav');

    // Cards container
    const cards = document.querySelectorAll(`#${containerId} .col`);

    // Remove active class from all tabs
    parentNav?.querySelectorAll('.nav-link').forEach(link => {
      link.classList.remove('active');
    });

    // Add active to clicked tab
    target.classList.add('active');

    // Filter cards
    cards.forEach((card: any) => {
      const cardYear = card.getAttribute('data-year');

      if (year === 'all' || cardYear === year) {
        card.classList.remove('d-none');
      } else {
        card.classList.add('d-none');
      }
    });
  }

}
